// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__jZxkh","productName":"Table_productName__1k9ld"};